export const COUNTRIES_CODE = [
  'AL',
  'DZ',
  'AD',
  'AO',
  'AR',
  'AM',
  'AW',
  'AU',
  'AT',
  'AZ',
  'BH',
  'BB',
  'BY',
  'BE',
  'BJ',
  'BM',
  'BO',
  'BA',
  'BW',
  'BR',
  'BG',
  'BF',
  'BI',
  'KH',
  'CM',
  'CA',
  'TD',
  'CL',
  'CN',
  'CO',
  'CG',
  'CR',
  'HR',
  'CU',
  'CY',
  'CZ',
  'CI',
  'DK',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'EE',
  'SZ',
  'ET',
  'FI',
  'FR',
  'GF',
  'PF',
  'GA',
  'GE',
  'DE',
  'GH',
  'GR',
  'GP',
  'GU',
  'GT',
  'GN',
  'GY',
  'HN',
  'HK',
  'HU',
  'IS',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IL',
  'IT',
  'JM',
  'JP',
  'JO',
  'KZ',
  'KE',
  'XK',
  'KW',
  'KG',
  'LV',
  'LB',
  'LY',
  'LI',
  'LT',
  'LU',
  'MK',
  'MG',
  'MY',
  'ML',
  'MT',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MX',
  'MD',
  'MC',
  'MN',
  'ME',
  'MA',
  'MZ',
  'NA',
  'NL',
  'AN',
  'NC',
  'NZ',
  'NI',
  'NE',
  'NG',
  'KP',
  'NO',
  'OM',
  'PK',
  'PA',
  'PY',
  'PE',
  'PH',
  'PL',
  'PT',
  'PR',
  'QA',
  'RE',
  'RO',
  'KN',
  'SM',
  'SA',
  'SN',
  'RS',
  'SG',
  'SK',
  'SI',
  'ZA',
  'KR',
  'ES',
  'SR',
  'SE',
  'CH',
  'SY',
  'TW',
  'TH',
  'BS',
  'TG',
  'TN',
  'TR',
  'TM',
  'UA',
  'AE',
  'GB',
  'US',
  'UY',
  'UZ',
  'VE',
  'VN',
  'YE',
  'ZW',
];
